import type { FaireProductEntity } from "../../entity_types/product";

export const p_k7y9hhxava: FaireProductEntity = {
  token: "p_k7y9hhxava",
  type: "product",
  name: "Quartz Crystal Point",
  brandToken: "b_wmrj23yq37",
  brandName: "Wildheart Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/b8d21da9bcdb390861cf606de6031d9dccb358a40a336930ea3516870de0eef8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/74fff53491b2130beefc9316f58b234c9662e31bb8f193d248ad6a8f3c64893b.jpeg",
    "https://cdn.faire.com/fastly/41cfa31a14033d1db18c29d3fcf41e86d5b7b2a9f5123fadb1cf5aec5fa10ea2.jpeg",
    "https://cdn.faire.com/fastly/a8e5dcafcae7a47e583ff0d919521040d1e7667edcbe3d399271dd9377258523.jpeg",
    "https://cdn.faire.com/fastly/6efae46de44b8f313068485f062e982c3ce5d56ffa19412db49ea22e57017384.jpeg",
    "https://cdn.faire.com/fastly/610e7a788f2dd98ea55431abd3d357121dd58955c3cd205d7b22270d79a2fce4.jpeg",
    "https://cdn.faire.com/fastly/fcaca7652d8282c63d6f422c635a769611e2d2326a69e2a39bf47ad389f31d3a.jpeg",
    "https://cdn.faire.com/fastly/d7993d803f7bc865703502e9f33f9850ed62e1cba8ec7845803c9c5caefed57b.jpeg",
    "https://cdn.faire.com/fastly/52f97ab3b39a6e67f4c82a4d7ed65adf9ada1f5aa2ccb88ee4084f7cbe9dec08.jpeg",
  ],
  priceDollars: 6.24,
  description:
    "Explore the spiritual influence of our Quartz Crystal Point from Wildheart Crystals. This Arkansas Quartz, imbued with Hematite, serves as a potent addition to any wellness routine. Not just a beautiful display piece, its natural metaphysical properties are said to balance energies and foster a positive environment. This gemstone is an embodiment of organic elegance. Enjoy the power of raw, untreated gems with our Quartz Crystal Point.",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:49.247Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
